import { render, staticRenderFns } from "./EditGroup.vue?vue&type=template&id=0223b394&"
import script from "./EditGroup.vue?vue&type=script&lang=js&"
export * from "./EditGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports